// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";

import {Colors} from "../../../assets/Colors";
import {fetchGet, fetchPost, fetchPut} from "../../../fetchers";
import {useMutation} from "@tanstack/react-query";
import {DynamicTableSimple} from "../../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {isRequired, useForm} from "../../../components/isRequired";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import 'react-toastify/dist/ReactToastify.css';
import {BiArrowBack, BiTrash} from "react-icons/bi";
import {useLocation, useNavigate, useParams} from "react-router-dom";

const DeletePurchaseRequisitionPage = ({}) => {
    let initialState = {
        BisnisUnitID: "",
        DatePR: new Date()
    };

    let initialStateModal = {
        SDTDate: new Date()
    };
    const validations = [(
        {UserPCName}) => isRequired(UserPCName) || {UserPCName: "Nama UserPC wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Status wajib diisi"},
        ({KelompokID}) => isRequired(KelompokID) || {KelompokID: "Kelompok wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Kelompok wajib diisi"},
        ({DetailAccountID}) => isRequired(DetailAccountID) || {DetailAccountID: "Detail Account wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Detail Account wajib diisi"},
    ];
    let user = JSON.parse(localStorage.getItem("user"));

    const getDataFromURL = (url) =>
        new Promise((resolve, reject) => {
            url = url.replaceAll("/", "-");
            setTimeout(() => {
                fetch(process.env.REACT_APP_API_URL+"Procurement/FilePriceComparison/" + url, {
                    method: "GET", // or 'PUT'
                    headers: {
                        Accept: "*/*",
                        Authorization: "Bearer " + user.Token,
                    },
                })
                    .then((response) => response.blob())
                    .then((data) => {
                        const file = window.URL.createObjectURL(data);
                        window.open(file);
                    });
            });
        }, 2000);
    const {
        changed,
        values,
        isValid,
        touched,
        submitHandler,
        customHandler,
        changeHandler,
        errors,
        blastChange
    } = useForm(initialState, validations);


    const barang = useMutation(formData => fetchGet("Master/Barang/min"))
    const [buttonTouched, setButtonTouched] = useState(false);
    const [detail, setDetail] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [modalDetail, setModalDetail] = useState(initialStateModal);
    const [modalID, setModalID] = useState(0);
    const ModalOpener = (detail) => {
        setShowModal(true)
    }
    const param = useLocation();
    const params = useParams();

    const mutationAdd = useMutation(formData => fetchPost("Procurement/PurchaseRequisition", formData))
    const mutationGet = useMutation(formData => fetchGet("Procurement/PurchaseRequisition/" + formData))
    const mutationUpdate = useMutation(formData => fetchPut("Procurement/PurchaseRequisition/batal", formData))

    const ModalEdit = (detail, id) => {
        setModalID(id)
        setModalDetail(detail)
        setShowModal(true)
        setShowModalEdit(true)
    }

    const ModalDelete = (id) => {
        let newDetail = [...detail]
        newDetail.splice(id, 1);
        setDetail(newDetail)
    }

    const navigate = useNavigate();

    useEffect(() => {
        barang.mutate()
        if (params.transid) {
            mutationGet.mutate(params.transid.replaceAll("-", "/"))
        }
        if (params.id) {
            customHandler(params.id, "BisnisUnitID")
        }
    }, []);


    useEffect(() => {
        if (mutationUpdate) {
            if (mutationUpdate.isSuccess) {
                navigate("/procurment/report/Material-and-Services-Request")
            }
        }
    }, [mutationUpdate.status]);

    useEffect(() => {
        if (mutationGet.data) {
            setDetail(mutationGet.data.data.PRList)
            blastChange(mutationGet.data.data)
        }
    }, [mutationGet.status]);


    const header = [
        {name: "Barang", key: "BarangID", modifiers: "Barang"},
        {name: "Qty", key: "Qty", modifiers: "number"},
        {name: "SDTDate", key: "SDTDate", modifiers: "dateOnly"},
        {name: "Specification", key: "Specification", modifiers: "Text"},
    ]


    const Kirim = (type) => {
        mutationUpdate.mutate({"PurchaseRequisitionID": params.transid.replaceAll("-", "/")})
    }


    return (<div className="md:ml-64">
        <div
            style={{background: Colors.primary}}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 px-4">
                    <Card>
                        <div className="flex flex-col  mt-5">
                            <div className="flex w-full justify-end flex-col sm:flex-row ">
                                <button
                                    onClick={() =>
                                        navigate("/procurment/report/Material-and-Services-Request")
                                    }
                                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                                    Kembali
                                </button>
                                <button
                                    onClick={() => Kirim()}
                                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-red-600 hover:bg-main-100 hover:text-white text-white font-semibold py-2 px-4 border border-red-900 shadow rounded"
                                >
                                    <BiTrash className="text-xl text-white pr-2"/>
                                    Hapus
                                </button>

                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"BisnisUnit"} value={values} name={"BisnisUnitID"}
                                                   title={"Bisnis Unit"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"dateOnly"} value={values} name={"DatePR"}
                                                   title={"Date PR"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"TipePR"} value={values} name={"Tipe"}
                                                   title={"Tipe"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"text"} value={values} name={"Requester"}
                                                   title={"Requester"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/2">
                                <HrdInputGenerator type={"text"} value={values} name={"Remarks"}
                                                   title={"Remarks"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="">
                                <div
                                    className="w-full px-3"
                                    onClick={() => getDataFromURL(values["NamaFile"])}
                                >
                                    <label
                                        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        {values["NamaFile"] && "Ganti "}
                                        Data pendukung
                                    </label>
                                    <label htmlFor={"NamaFile"}
                                           className="block w-1/4 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500">{
                                        values["NamaFile"]
                                            ?
                                            <span>File Selected - {values["NamaFile"].name ? values["NamaFile"].name : values["NamaFile"]}</span>
                                            : <span>Choose a file...</span>}
                                    </label>

                                    <div
                                        type="file"
                                        id={"NamaFile"}
                                        key={"NamaFile"}
                                        name={"NamaFile"}
                                        style={{visibility: "hidden"}}
                                        className="block  border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                    />
                                </div>
                            </div>
                            <hr/>
                            <DynamicTableSimple data={detail}
                                                header={header}
                                                OnClick={ModalOpener}
                                                name={"Purchase Requisition"}
                                                barang={barang.data}
                                                edit={ModalEdit}
                                                delete={ModalDelete}
                            />
                        </div>
                    </Card>

                </div>
            </div>
        </div>
    </div>);
};

export default DeletePurchaseRequisitionPage;
